import User from "../../User";

export default class CartaIdComponent {
	
	id?: string;

    customFields!: CustomField;

    type!: string;

    componentKey!: string;

	displayName?: string;
	
	givenName?: string;
	
	surname?: string;

	constructor(obj: any) {
		Object.assign(this, obj);
		this.customFields = new CustomField(obj?.customFields);
	};

	public fromUser(obj?: User): CustomField {
		this.id = obj?.id;
		const customFields = {first_name: obj?.givenName, last_name: obj?.surname, contact_email: obj?.userPrincipalName.address };
    	return new CustomField(customFields);
    }
}

class CustomField {

	first_name!: string;

	last_name!: string;

	contact_email!: string;

	job_title!: string;

	constructor(obj: any) {
		Object.assign(this, obj);
	}
}
